const ur = {
  common: {
    home: "ہوم",
    materials: "میٹیریلز",
    rateCard: "ریٹ کارڈ",
    cart: "کارٹ",
    myBookings: "میری بکنگز",
    login: "لاگ اِن",
    signup: "سائن اپ",
    dashboard: "ڈیش بورڈ",
    settings: "سیٹنگز",
    logout: "لاگ آؤٹ",
    save: "محفوظ کریں",
    loading: "لوڈ ہو رہا ہے...",
  },
  header: {
    brand: "مستری بازار",
  },
  settings: {
    title: "سیٹنگز",
    subtitle: "اپنا پروفائل، زبان، پتہ اور اکاؤنٹ ترجیحات مینیج کریں۔",
    profileSection: "پروفائل",
    languageSection: "زبان",
    addressSection: "محفوظ شدہ پتہ",
    accountSection: "اکاؤنٹ",
    fullName: "پورا نام",
    phone: "فون نمبر",
    email: "ای میل",
    city: "شہر",
    preferredLanguage: "پسندیدہ زبان",
    flatHouseNo: "فلیٹ نمبر / مکان نمبر",
    streetArea: "گلی / علاقہ",
    state: "ریاست",
    country: "ملک",
    pincode: "پن کوڈ",
    role: "کردار",
    uniqueId: "یونیک آئی ڈی",
    saveProfile: "پروفائل محفوظ کریں",
    saveAddress: "پتہ محفوظ کریں",
    accountDetails: "اکاؤنٹ تفصیلات",
  },
  home: {
    heroTitle: "مستری بازار",
    heroText:
      "سروسز بک کریں، میٹیریلز خریدیں، اپنا گھر بنائیں، اور لوکل کوآرڈینیشن، چھپے اخراجات اور غیر یقینی ٹائم لائن کی پریشانی کم کریں۔",
    buyMaterials: "میٹیریلز خریدیں",
    buildYourHouse: "اپنا گھر بنائیں",
    exploreMembership: "ممبرشپ دیکھیں",
    services: "سروسز",
    about: "ہمارے بارے میں",
    contactUs: "رابطہ کریں",
    privacyPolicy: "پرائیویسی پالیسی",
    terms: "شرائط و ضوابط",
  },
};

export default ur;